import React, { useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getTicketForFallback,
  refreshApplicationResultForFallback,
  updateTicketDeadlineForFallback,
} from "../Store/Thunk";

const TicketEditor = () => {
  const dispatch = useDispatch();
  const fetchedTicket = useSelector((state) => state.ticketEditor.fetchedTicket);

  const [inputValue, setInputValue] = useState("");
  const [parsedData, setParsedData] = useState(null);
  const [error, setError] = useState("");
  const [editorData, setEditorData] = useState();

  // Function to validate and parse input
  const parseCode = (code) => {
    const regex = /^#(\d)A(\d+)T(\d+)R(\d+)$/; // Match format #0a12t55
    const match = code.match(regex);

    if (!match) {
      setError("Invalid format! Use #<appType>a<appId>t<ticketId> (e.g., #0a12t55)");
      setParsedData(null);
      return;
    }

    // Extract values
    const applicationType = parseInt(match[1], 10);
    const applicationId = parseInt(match[2], 10);
    const ticketId = parseInt(match[3], 10);
    const resultId = parseInt(match[4], 10);

    dispatch(
      getTicketForFallback({
        applicationId,
        applicationType,
        ticketId,
      })
    );

    setParsedData({ applicationType, applicationId, ticketId, resultId });
    setError("");
    console.log(applicationType, applicationId, ticketId, 123123, resultId);
  };

  return (
    <Row>
      <Col>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            parseCode(inputValue);
          }}
        >
          <Row className="align-items-center">
            <Col xs={5}>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Enter code (e.g., #0a12t55)"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  pattern="^#\d+A\d+T\d+R\d+$"
                  required
                />
              </Form.Group>
            </Col>
            <Col xs={"auto"}>
              <Button type="submit" className="btn btn-primary w-100">
                Get
              </Button>
            </Col>
            <Col xs={"auto"}></Col>
          </Row>
        </Form>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}

        {parsedData && (
          <Alert variant="success" className="mt-3">
            <Row>
              <Col>
                <Row>
                  <Col xs={4} className={"fw-bold"}>
                    Application Type:
                  </Col>
                  <Col xs={"auto"}>{parsedData.applicationType}</Col>
                </Row>
                <Row>
                  <Col xs={4} className={"fw-bold"}>
                    Application ID:
                  </Col>
                  <Col xs={"auto"}>{parsedData.applicationId}</Col>
                </Row>
                <Row>
                  <Col xs={4} className={"fw-bold"}>
                    Ticket ID:
                  </Col>
                  <Col xs={"auto"}>{parsedData.ticketId}</Col>
                </Row>
                <Row>
                  <Col xs={4} className={"fw-bold"}>
                    Result ID:
                  </Col>
                  <Col xs={"auto"}>{parsedData.resultId}</Col>
                </Row>
              </Col>

              <Col xs={"auto"}>
                <Row className={"mb-2"}>
                  <Button
                    onClick={() => {
                      dispatch(updateTicketDeadlineForFallback({ ticketId: parsedData.ticketId }));
                    }}
                  >
                    Reset Deadline
                  </Button>
                </Row>
                <Row>
                  <Button
                    onClick={() => {
                      dispatch(
                        refreshApplicationResultForFallback({
                          applicationType: parsedData.applicationType,
                          resultId: parsedData.resultId,
                        })
                      );
                    }}
                  >
                    Refresh Results
                  </Button>
                </Row>
              </Col>
            </Row>
          </Alert>
        )}
        {/*<ObjectEditor setEditorData={setEditorData} propData={fetchedTicket}></ObjectEditor>*/}
      </Col>
    </Row>
  );
};
export default TicketEditor;
